import ActivityDrawer from "../../../../parts/activity-drawer/ActivityDrawer";
import BodyFat from "./BodyFat";
import _ from "lodash";
import { isAdminOrOwner } from "../../../../utils/organization-permissions-helpers";

const BodyFatController = async (app) => {
  app.get("/body-fat", async ({ res, req, locals, load }) => {
    const { query } = req;

    const isAllowToViewAllOrganizationsAthletes = isAdminOrOwner(
      locals.organizationRoleName
    );

    if (
      locals.activeUser.organizationId &&
      isAllowToViewAllOrganizationsAthletes &&
      !locals.allAthletesFromOrganization
    ) {
      await load("allAthletesFromOrganization");
    }

    const modal = _.get(query, "modal", {});
    locals.modal = {
      "activity-feed": <ActivityDrawer />,
    }[modal.type];
    res.body = <BodyFat />;
  });
};

export default BodyFatController;
